import type { PortraitStudent } from '@/api/types/portrait'

type PortraitStudentName = Pick<PortraitStudent, 'studentFirstName' | 'studentLastName'>

/** "First Last" with missing parts dropped; '' for a student with no name at all. */
export function formatPortraitStudentName(student: PortraitStudentName): string {
  return [student.studentFirstName, student.studentLastName]
    .map((part) => part?.trim() ?? '')
    .filter(Boolean)
    .join(' ')
}

/**
 * Distinct full names for the search dropdown, in the order given — the load service already ranks
 * rows by closeness, so the first occurrence of a name keeps that rank. A student with several
 * portraits is several rows, and two students can share a name; either way the name shows once.
 * Comparison ignores case so "ada lovebot" and "Ada Lovebot" aren't listed twice.
 */
export function suggestPortraitStudentNames(
  students: readonly PortraitStudentName[],
  limit: number
): string[] {
  const seen = new Set<string>()
  const names: string[] = []

  for (const student of students) {
    const name = formatPortraitStudentName(student)
    const key = name.toLowerCase()

    if (!name || seen.has(key)) continue

    seen.add(key)
    names.push(name)
    if (names.length >= limit) break
  }

  return names
}
